import { apiDiscountCodesGroup } from './apiGroup/discountCodes'
import { apiReportsGroup } from './apiGroup/reports'
import { apiProductionGroup } from '@/api/apiGroup/production'
import { apiCampaignsGroup } from './apiGroup/campaigns'
import { apiEmployee } from './apiGroup/apiEmployee'
import { apiEmployeeInvites } from './apiGroup/apiEmployeeInvites'
import { apiRolesPermissions } from './apiGroup/apiRolesPermissions'
import { apiTransactions } from './apiGroup/apiTransactions'
import { apiAuth } from './apiGroup/auth'
import { apiClients } from './apiGroup/clients'
import { apiDietary } from './apiGroup/dietary'
import { apiDiscounts } from './apiGroup/discounts'
import { apiOrdersGroup } from './apiGroup/orders'
import { apiPointsGroup } from './apiGroup/points'
import { apiPrices } from './apiGroup/prices'
import { apiPromo } from './apiGroup/promotions'
import { apiSystemGroup } from './apiGroup/system'
import { apiGadgetsGroup } from './apiGroup/gadgets'
import { apiFridgeSlots } from './apiGroup/fridge/apiFridgeSlots'

export const ApiService = {
	...apiAuth,
	...apiEmployee,
	...apiRolesPermissions,
	...apiEmployeeInvites,
	...apiClients,
	...apiDietary,
	...apiPrices,
	...apiOrdersGroup,
	...apiTransactions,
	...apiPromo,
	...apiDiscounts,
	...apiCampaignsGroup,
	...apiDiscountCodesGroup,
	...apiPointsGroup,
	...apiProductionGroup,
	...apiSystemGroup,
	...apiGadgetsGroup,
	...apiFridgeSlots,
	...apiReportsGroup,
}
